<template>
  <div>
    <b-modal
      size="md"
      centered
      ok-title="Enviar"
      id="modal-email-token"
      modal
      @hide="closeModal"
      :title="titleModal"
    >
      <div class="login">
        <!-- <div v-show="errorCredentials" class="alert alert-warning text-center">
          <span v-text="$ml.get('tryAgain')"
            >Por favor, revise os dados fornecidos e tente novamente.</span
          >
        </div> -->
        <div
          v-if="status && actionType === 'activeLocker'"
          class="alert alert-warning text-center"
        >
          <span v-text="$ml.get('alertInactiveLocker')"
            >Atenção: Ao desativar o cofre de relatórios, todos os relatórios
            armazenados serão permanentemente removidos.</span
          >
        </div>
        <div
          v-if="status && actionType === 'SSO'"
          class="alert alert-warning text-justify"
        >
          <span v-text="$ml.get('textWarningDisableSSO')" >Atenção! Ao desativar o SSO, todos os usuários, exceto o "Owner", serão desativados da plataforma. A reativação deverá ser realizada manualmente por meio do menu "Usuários".</span
          >
        </div>
        <div v-if="!status && actionType === 'activeLocker'">
          <label class="text-muted" v-text="$ml.get('tooltipLocker')">O Cofre de Relatórios permite armazenar relatórios críticos ou antigos com segurança, acessíveis apenas via autenticação extra.</label>
        </div>
        <div v-if="!status && actionType === 'SSO'">
          <label class="text-muted" v-text="$ml.get('tooltipDescriptionSSSO')">Com o SSO (Login Único), você pode acessar a plataforma de maneira prática, utilizando apenas uma conta.</label>
        </div>
        <div class="form-group" v-if="actionType != 'activeLocker' && actionType != 'SSO' && !ssoIsActive">
          <label class="text-muted" v-text="$ml.get('confirmPasswordLabel')"
            >Confirme a sua senha de acesso à plataforma para finalizar a ação
            desejada.</label
          >
          <input
            type="password"
            class="form-control"
            v-model="password"
            placeholder="*********"
            :style="{ border: errorPassword ? '1px solid red' : '' }"
          />
          <transition name="fade">
            <label
              class="lblError"
              v-if="errorCredentials"
              v-text="$ml.get('invalidPassword')"
              >Senha inválida.</label
            >
          </transition>
        </div>
        <div v-else class="form-group">
          <label class="text-muted" v-text="$ml.get('useCodeEmail')"
            >Use o código recebido por email</label
          >
          <the-mask
            class="form-control"
            v-model="codeEmail"
            :mask="['### ###']"
            :placeholder="$ml.get('enterTheCode')"
          />
          <div
            class="col-24"
            :style="[
              { display: errorCodeEmail || errorDomain ? 'flex' : '' },
              { 'flex-wrap': errorCodeEmail || errorDomain ? 'wrap' : '' },
              {
                'justify-content': errorCodeEmail || errorDomain ? 'space-between' : '',
              },
            ]"
          >
            <transition name="fade">
              <label
                v-if="errorCodeEmail"
                style="position: relative; !important"
                class="lblError"
                v-text="$ml.get('tokenIsInvalid')"
              >
                O token é inválido ou já foi utilizado.
              </label>
              <label
                v-if="errorDomain"
                style="position: relative; !important"
                class="lblError"
                v-text="$ml.get('textErrorDomain')"
              >
                É necessário registrar e validar o domínio do owner antes de prosseguir.
              </label>
            </transition>
            <label
              v-if="!errorAwaitNewRequest"
              :style="[ { 'margin-left': errorDomain ? '4px' : '' }]"
              style="color: #730ba9; cursor: pointer; font-size: 12px; white-space: nowrap;"
              @click="getToken(actionType)"
              >{{
                timeLeftEmail > 0
                  ? `${$ml.get("requestNewCodeEmail")} ${formattedTimeEmail}`
                  : $ml.get("receiveCode")
              }}</label
            >
            <label v-else-if="errorAwaitNewRequest && !errorCodeEmail && !errorDomain" class="lblError" v-text="$ml.get('awaitNewToken')">Aguarde! Em breve, você poderá solicitar um novo token.</label>
          </div>
        </div>
      </div>
      <template #modal-footer="{ ok }">
        <b-button
          style="background: #730ba9; min-width: 90px"
          :disabled="(!codeEmail && !password) || loadingBtn"
          size="sm"
          @click="changeMethodAuthentication(ok)"
        >
          <Spinner v-if="loadingBtn" />
          <span v-else>{{ $ml.get("confirmBtn") }}</span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import lockerService from "../../services/locker.service";
import ssoService from "../../services/sso.service";
export default {
  name: "ModalConfirmEmailToken",
  props: ["actionType", "status"],
  data() {
    return {
      password: "",
      errorPassword: false,

      codeEmail: "",
      errorCodeEmail: false,
      timeLeftEmail: 0,
      formattedTimeEmail: "",
      errorCredentials: false,
      loadingBtn: false,
      errorDomain: false,
      ssoIsActive: false,
      errorAwaitNewRequest: false,
    };
  },
  watch:{
    codeEmail(){
      this.errorCodeEmail = false;
    },
    password(){
      this.errorCredentials = false;
    }
  },
  computed: {
    titleModal() {
      let title = this.$ml.get('credentials');
      if (this.actionType === "activeLocker" && this.status) {
        title = this.$ml.get('disableLocker');
      } else if (this.actionType === "activeLocker" && !this.status) {
        title = this.$ml.get('activeLocker');
      } else if (this.actionType === "appToken") {
        title = this.$ml.get('disable2faSwal');
      } else if (this.actionType === "smsToken") {
        title = this.$ml.get('disableSms');
      } else if (this.actionType === "emailToken") {
        title = this.$ml.get('disableEmail');
      }
      else if (this.actionType === "SSO" && !this.status) {
        title = this.$ml.get('activeSSO');
      }
      else if (this.actionType === "SSO" && this.status) {
        title = this.$ml.get('inactiveSSO');
      }
      return title;
    },
  },
  mounted(){
    const {enabled} = this.$store.getters['getUser']?.ssoSettings
    this.ssoIsActive = enabled;
  },
  methods: {
    getToken(type) {
      switch (type) {
        case 'SSO':
          this.sendCodeEmailSSO();
          break;
        case 'activeLocker':
          this.sendCodeEmail();
          break;
        default:
          if(this.ssoIsActive){
            this.sendCodeEmail();
            return;
          }
          console.log("Ação inválida!");
          break;
      }
    },

    closeModal() {
      this.password = "";
      this.codeEmail = "";
      this.errorPassword = false;
      this.errorCodeEmail = false;
      this.errorCredentials = false;
      this.$emit("hideModal");
    },
    async sendCodeEmail() {
      this.errorAwaitNewRequest = false;
      if (this.timeLeftEmail > 0) return;

      const newCodeRequest = 300;
      this.timeLeftEmail = newCodeRequest;

      const interval = setInterval(() => {
        if (this.timeLeftEmail > 0) {
          this.timeLeftEmail--;

          const minutes = Math.floor(this.timeLeftEmail / 60);
          const seconds = this.timeLeftEmail % 60;

          this.formattedTimeEmail = `${minutes}:${seconds
            .toString()
            .padStart(2, "0")}`;
        } else {
          clearInterval(interval);
          this.errorAwaitNewRequest = false;
        }
      }, 1000);

      try {
        const { status } = await lockerService.getTokenEmailLocker();

        if (status === 200) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("sendToken"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (error) {
        console.log(error.response);
        if (
          error.response.data.message ===
          "Aguarde 5 minutos para receber outro token"
        ) {
          this.errorAwaitNewRequest = true;
        }
      }
    },

    async sendCodeEmailSSO() {
      this.errorAwaitNewRequest = false;
      if (this.timeLeftEmail > 0) return;

      const newCodeRequest = 300;
      this.timeLeftEmail = newCodeRequest;

      const interval = setInterval(() => {
        if (this.timeLeftEmail > 0) {
          this.timeLeftEmail--;

          const minutes = Math.floor(this.timeLeftEmail / 60);
          const seconds = this.timeLeftEmail % 60;

          this.formattedTimeEmail = `${minutes}:${seconds
            .toString()
            .padStart(2, "0")}`;
        } else {
          clearInterval(interval);
          this.errorAwaitNewRequest = false;
        }
      }, 1000);

      try {
        const { status } = await ssoService.getEmailTokenSSO();

        if (status === 200) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("sendToken"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (error) {
        console.log(error.response);
        if (
          error.response.data.message ===
          "Aguarde 5 minutos para receber outro token"
        ) {
          this.errorAwaitNewRequest = true;
        }
      }
    },

    changeMethodAuthentication() {
      this.$emit("credentials", {
        emailToken: this.codeEmail,
        password: this.password,
      });
    },
  },
};
</script>
